import React from "react";
import { Field, ErrorMessage } from "formik";
import { FormikReactSelect } from "../../common/FormikReactSelect";
import { Styles } from "react-select";
import { USA_States } from "./data/USA_States";
import { retailers } from "./data/retailers";
import { distributors } from "./data/distributors";

interface DistributionPageProps {
  selectCustomStyles?: Partial<Styles>;
};

export const DistributionPage = ({ selectCustomStyles }: DistributionPageProps) => (
<>
  <Field 
    name="state"
    as={FormikReactSelect} 
    options={USA_States} 
    customStyles={selectCustomStyles} 
    placeholder="State where your product is manufactured"
  />
  <ErrorMessage name="state" component="div" />
  <Field
    name="retailers" 
    as={FormikReactSelect} 
    isMulti options={retailers} 
    customStyles={selectCustomStyles} 
    placeholder="Where is your product sold?"
  />
  <ErrorMessage name="retailers" component="div" />
  <Field
    name="distributors" 
    as={FormikReactSelect} 
    isMulti options={distributors} 
    customStyles={selectCustomStyles} 
    placeholder="Is this product available through distributors?"
  />
  <ErrorMessage name="distributors" component="div" />
</>
);
